<template>
  <div class="entreprise-linkbar">
    <router-link
      v-for="link in linkList"
      :key="link.url"
      :to="`/admin/entreprise/${entrepriseId}/${link.url}`"
    >
      {{ link.displayText }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: "EntrepriseNavBar",
  props: {
    entrepriseId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      linkList: [
        {
          displayText: "Tableau de bord",
          url: "stats",
        },
        {
          displayText: "Liste des employés",
          url: "employees",
        },
        {
          displayText: "Forfait",
          url: "forfait",
        },
        {
          displayText: "Profil",
          url: "profil",
        },
      ],
    };
  },
};
</script>

<style scoped>
.entreprise-linkbar {
  background-color: #29689c;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-top: 0.5rem;
}
.entreprise-linkbar a {
  color: white;
  padding: 0.5rem 1rem;
  flex-basis: auto;
}
.entreprise-linkbar a:hover {
  text-decoration: none;
}
</style>
